/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    class="col-lg-10"
  >
    <form @submit.prevent="save">
      <div class="form-group">
        <label
          for="assignmentName"
          class="control-label"
        >
          Name
        </label>
        <input
          id="assignmentName"
          v-model.trim="assignment.name"
          type="text"
          class="form-control"
          placeholder="assignment name"
          name="name"
          style="max-width: 300px"
          required
          maxlength="100"
        >
        <br><br>
        <label
          for="assignmentDescription"
          class="control-label"
        >
          Assignment Instructions
        </label>
        <textarea
          id="assignmentDescription"
          v-model.trim="assignment.description"
          type="text"
          class="form-control"
          placeholder="assignment instructions"
          name="name"
          style="width: 90%; height: 300px;"
          required
        />
      </div>

      <div
        v-if="showSharing"
        class="form-group"
      >
        <strong>Can Other Coaches Use This Template?</strong><br>
        <label
          for="isSharedAssignment1"
          class="radio-inline"
        >
          <input
            id="isSharedAssignment1"
            v-model="assignment.isShared"
            type="radio"
            name="isSharedAssignment"
            :value="true"
            :disabled="isSharingDisabled"
            tabindex="0"
          >
          Share Template with All Coaches in {{ $store.getters.org.name }}
        </label>
        <label
          for="isSharedAssignment2"
          class="radio-inline"
        >
          <input
            id="isSharedAssignment2"
            v-model="assignment.isShared"
            type="radio"
            name="isSharedAssignment"
            :value="false"
            :disabled="isSharingDisabled"
            tabindex="0"
          >
          Only I Can See This
        </label>
      </div>

      <router-link
        :to="{ name: 'coach-dashboard' }"
      >
        <button
          type="button"
          class="btn clear-btn"
        >
          Cancel / Previous
        </button>
      </router-link>
      <loading-button
        style="float:right"
        :loading="saving"
      >
        Save and Continue
      </loading-button>
    </form>
  </div>
</template>

<script>
export default {
  props: [ 'assignment' ],
  data() {
    return {
      errors: [],
      saving: false,
    };
  },
  computed: {
    showSharing() {
      // New templates are never disabled
      if (!('isTemplate' in this.assignment)) {
        return true;
      }
      return this.assignment.isTemplate;
    },
    isSharingDisabled() {
      // New templates are never disabled
      if (!('userId' in this.assignment)) {
        return false;
      }
      return (this.$store.getters.user.userId != this.assignment.userId);
    }
  },
  watch: {
  },
  methods: {
    save() {
      this.saving = true;
      this.errors = [];

      const action = (this.assignment.assignmentId) ?
        'updateAssignment' : 'addAssignment';
      this.$store.dispatch(action, {assignment: this.assignment})
        .then((assignment) => {
          if (action === 'addAssignment') {
            // send to edit page
            return this.$emit('advanceAssignmentEditor', assignment.assignmentId);
          }
          this.$emit('advanceAssignmentEditor');
        })
        .catch(() => {
          this.saving = false;
        });
    },
  }
};
</script>
